import VLazyImage from "v-lazy-image/v2/v-lazy-image.es.js";
import { Card, Button, Carousel, ProgressBar } from "@/components";
import { gtmMixin } from "@/mixins";
import mixins from "vue-typed-mixins";
export default mixins(gtmMixin).extend({
    components: {
        Card,
        Button,
        Carousel,
        ProgressBar,
        VLazyImage,
    },
    props: {
        hideImage: {
            type: Boolean,
            default: false,
        },
    },
    data: () => ({
        carouselHowToOptions: {
            slidesPerView: 1,
            spaceBetween: 2,
            loop: true,
            autoHeight: false,
        },
        activeStep: 0,
    }),
    computed: {
        items() {
            return this.$getContent("app.registrationSteps.items");
        },
    },
    methods: {
        trackOnClick() {
            this.gtmClickButton("video_cara_aktivasi");
        },
    },
});
